module.exports = __webpack_public_path__ + "img/sl.f6315f74.svg";